module.exports = __webpack_public_path__ + "static/media/wedding1.967fcbe6.jpg";